'use strict';

import '../sass/user.scss';
import './localStorage';
import { loginSystem } from './login';
import { loadStart, manageErrorBox } from './uxManagement';
import './qrCode';
import { setBasketStatus, sendBasketForPayment, sendCardPayment } from './checkout';
import { searchForProducts } from './products';

loginSystem();
loadStart();
searchForProducts();

const purchaseButton = document.getElementById('purchase-button');
purchaseButton.addEventListener('click', function(event) {
  this.disabled = true;
  this.textContent = 'Skickar order, vänta';
  event.preventDefault();
  const paymentTypeRadio = document.getElementsByName('payment-type');
  let choosenPaymenType = '';
  let i = 0;
  for (i = 0; i < paymentTypeRadio.length; i++) {
    if (paymentTypeRadio[i].checked) {
      choosenPaymenType = paymentTypeRadio[i].value;
    }
  }

  $.post('https://pyramidplus.webblandskapet.se/debug/index.php', { company: 'honsboa', data: choosenPaymenType, action: 'choosenPaymenType' });
  if (choosenPaymenType == 'swish') {
    sendBasketForPayment('S');
  } else if (choosenPaymenType == 'card') {
    sendCardPayment();
  } else if (choosenPaymenType == 'invoice') {
    sendBasketForPayment('I');
  } else {
    manageErrorBox('Du måste välja hur du vill betala', 'Du måste välja något av följande alternativ, Swish, betalkort eller Faktura.');
  }
});

if (window.location.search && window.location.search.indexOf('?swish=done&requestid=') > -1) {
  const urlParams = new URLSearchParams(window.location.search);
  const paymentRequestId = urlParams.get('requestid');
  let alreadySent = false;
  if (paymentRequestId) {
    let status = urlParams.get('status');
    if (status) {
      status = JSON.parse(status);
      if (localStorage.getItem('orders')) {
        const orders = JSON.parse(localStorage.getItem('orders'));
        for (let i = 0; i < orders.length; i++) {
          if (parseInt(orders[i]) === parseInt(paymentRequestId)) {
            window.location.href = 'https://butik.honsboa.se/';
            alreadySent = true;
          }
        }
        orders.push(paymentRequestId);
        localStorage.setItem('orders', JSON.stringify(orders));
      } else {
        localStorage.setItem('orders', JSON.stringify([paymentRequestId]));
      }

      if (status.result == 'paid' && !alreadySent) {
        $.post('https://pyramidplus.webblandskapet.se/debug/index.php', { company: 'honsboa', data: paymentRequestId, action: 'rad 21' });
        $.get('https://butik.honsboa.se/check_pyramid.php?check_order=' + paymentRequestId, function(data) {
          if (data == 'ok') {
            setBasketStatus(paymentRequestId, 'Done', '', true);
          }
        });
      } else {
        if (!alreadySent) {
          $.post('https://pyramidplus.webblandskapet.se/debug/index.php', { company: 'honsboa', data: paymentRequestId, action: 'rad 25' });
          setBasketStatus(paymentRequestId, 'Cancel', 'Om varukorgen är tom här, kolla i en annan flik', true);
        }
      }
    } else {
      $.post('https://pyramidplus.webblandskapet.se/debug/index.php', { company: 'honsboa', data: paymentRequestId, action: 'rad: 30' });

      setBasketStatus(paymentRequestId, 'Cancel', 'Om varukorgen är tom här, kolla i en annan flik', true);
    }
  }
}
